import { defineComponent, ref } from 'vue';
import DocumentTableComponent from '@/components/documentTable/DocumentTable.vue';
import DocumentFormComponent from '@/components/documentTable/documentForm/DocumentForm.vue';

export default defineComponent({
  name: 'DocumentPage',
  components: {
    DocumentTableComponent,
    DocumentFormComponent
  },
  setup: () => {
    const selectedDocumentId = ref<number | null>();
    const documentForm = ref<InstanceType<typeof DocumentFormComponent>>();

    const createClick = () => {
      Promise.resolve(selectedDocumentId.value = null)
        .then(() => documentForm.value?.show());
    };

    const editClick = (carouselId: number) => {
      Promise.resolve(selectedDocumentId.value = carouselId)
        .then(() => documentForm.value?.show());
    };

    return {
      selectedDocumentId,
      documentForm,
      createClick,
      editClick,
    };
  },
});
